export default {
        NO:'No, not right now',
        YES:'Yes, add another one',
}